const HOME = "/";
const BIBLIOTECA = "/biblioteca";
const INFOAUDIOLIBRO = "/infoAudioLibro/:bookId";
const LOGIN = '/login';
const REGISTER = '/register';
const PERFIL = '/perfil';
const DISCOVER = '/discover';
const UPLOADBOOK = '/upload';
const FORGETPASS = '/login/forgetPass';
const USERPROFILE = '/perfil'
const PUBLICPROFILE = '/publicprofile/:userId'


export {
    HOME,
    BIBLIOTECA,
    LOGIN,
    REGISTER,
    PERFIL,
    UPLOADBOOK,
    DISCOVER,
    FORGETPASS,
    INFOAUDIOLIBRO,
    USERPROFILE,
    PUBLICPROFILE
} 

